var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(v,k){return _c('el-option',{key:k,attrs:{"value":v.id,"label":v.title}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }